import type { Client } from "@opensea/graphql"
import { graphql, prefetch } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"
import { DEFAULT_FILTER, DEFAULT_SORT, PAGE_SIZE } from "../constants"
import { CollectionHoldersTableRowFragment } from "./CollectionHoldersTableRow"

export const CollectionTopOfferQuery = graphql(
  `
    query CollectionTopOfferQuery($collectionSlug: String!) {
      collectionBySlug(slug: $collectionSlug) {
        __typename
        ... on Collection {
          topOffer {
            pricePerItem {
              ...TokenPrice
            }
          }
        }
      }
    }
  `,
  [TokenPriceFragment],
)

export const CollectionHoldersQuery = graphql(
  `
    query CollectionHoldersQuery(
      $collectionSlug: String!
      $limit: Int!
      $cursor: String
      $filter: CollectionHoldersFilter
      $sort: CollectionHoldersSort!
    ) {
      collectionHolders(
        slug: $collectionSlug
        limit: $limit
        cursor: $cursor
        filter: $filter
        sort: $sort
      ) {
        items {
          quantity
          profile {
            address
          }
          ...CollectionHoldersTableRow
        }
        nextPageCursor
      }
    }
  `,
  [CollectionHoldersTableRowFragment],
)

export const prefetchCollectionHoldersQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionHoldersQuery, {
    collectionSlug,
    limit: 1,
    sort: DEFAULT_SORT,
  })
}

export const prefetchCollectionHoldersQueryPage = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionHoldersQuery, {
    collectionSlug,
    filter: DEFAULT_FILTER,
    limit: PAGE_SIZE,
    sort: DEFAULT_SORT,
  })
}

export const prefetchCollectionTopOfferQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionTopOfferQuery, { collectionSlug })
}
